import Assistance from './pages/assistance/assistance';

document.addEventListener('DOMContentLoaded', (e) => {
  new Assistance().init();
});
